import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WhatPlatformService } from '../providers/what-platform-service/whatPlatformService';

@Injectable({
  providedIn: 'root'
})
export class IsNotPWAGuard implements CanActivate {
  constructor (private router: Router, private whatPlatformService:WhatPlatformService) {
  }

  public canActivate (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.whatPlatformService.isPWA()) {
      return false;
    } else {
      return true;
    }
  }
}
